module.exports = __webpack_public_path__ + "img/section-01@3x.1c6beff6.png";